import { render, staticRenderFns } from "./TabThirds.vue?vue&type=template&id=76071603&"
import script from "./TabThirds.vue?vue&type=script&lang=js&"
export * from "./TabThirds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports